// src/services/activityLogService.js
import api from './api';

const activityLogService = {
  /**
   * Obtener todas las actividades con filtros opcionales
   * @param {Object} filters - Filtros: type, module, user_id, limit, offset
   * @returns {Promise<Object>} - Lista de actividades y conteo
   */
  getActivityLogs: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.type) params.append('type', filters.type);
      if (filters.module) params.append('module', filters.module);
      if (filters.user_id) params.append('user_id', filters.user_id);
      if (filters.limit) params.append('limit', filters.limit);
      if (filters.offset) params.append('offset', filters.offset);
      
      const response = await api.get(`/activity-logs?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error en getActivityLogs:', error);
      throw error;
    }
  },

  getSecurityEvents: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.severity) params.append('severity', filters.severity);
    if (filters.event_type) params.append('event_type', filters.event_type);
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    if (filters.limit) params.append('limit', filters.limit);
    const response = await api.get(`/activity-logs/security-events?${params.toString()}`);
    return response.data;
  },

  getSecurityEvidence: async () => {
    const response = await api.get('/activity-logs/security-evidence');
    return response.data;
  },

  /**
   * Obtener una actividad específica por ID
   * @param {number} id - ID de la actividad
   * @returns {Promise<Object>} - Datos de la actividad
   */
  getActivityLogById: async (id) => {
    try {
      const response = await api.get(`/activity-logs/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error en getActivityLogById:', error);
      throw error;
    }
  },

  /**
   * Obtener estadísticas de actividades
   * @returns {Promise<Object>} - Estadísticas: total, hoy, semana, por tipo, por módulo
   */
  getStats: async () => {
    try {
      const response = await api.get('/activity-logs/stats');
      return response.data;
    } catch (error) {
      console.error('Error en getStats:', error);
      throw error;
    }
  },

  /**
   * Crear un nuevo log de actividad
   * @param {Object} logData - Datos del log: type, module, action, target, details
   * @returns {Promise<Object>} - Respuesta del servidor
   */
  createLog: async (logData) => {
    try {
      const response = await api.post('/activity-logs', logData);
      return response.data;
    } catch (error) {
      console.error('Error en createLog:', error);
      throw error;
    }
  },

  /**
   * Obtener actividades recientes de un usuario
   * @param {number} userId - ID del usuario
   * @param {number} limit - Límite de resultados (default: 20)
   * @returns {Promise<Object>} - Actividades recientes del usuario
   */
  getUserRecentActivity: async (userId, limit = 20) => {
    try {
      const response = await api.get(`/activity-logs/user/${userId}/recent?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error en getUserRecentActivity:', error);
      throw error;
    }
  },
};

export default activityLogService;
